import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import stripelogo from "../../../assets/svg/stripe.svg";
import paypallogo from "../../../assets/svg/paypal.svg";
import bitpaylogo from "../../../assets/svg/bitpay.svg";
import paystacklogo from "../../../assets/svg/paystack.svg";
import phonepelogo from "../../../assets/images/razorpay-logo.png";
import pesalogo from "../../../assets/svg/pesa.svg";
import Legalcomponet from "./Legalcomponet";
// import PaymentIntegration from "./PaymentIntegration";
import PaymentIntegrationoptions from "./PaymentIntegration";

export default function Connectpayment({ checkHeader, checkbtn }) {
  const [legalData, setLegalData] = useState({
    agreement: false,
    payment: false,
  });
  const [value, setValue] = useState(false); // Corrected typo 'flase' to 'false'

  const handleLegalChange = (data) => {
    setLegalData(data);
    // console.log("Updated Legal Data: ", data);
  };

  useEffect(() => {
    checkHeader(legalData);
  }, [legalData]);

  const handleButtonClick = (data) => {
    // console.log("Button Clicked. Legal Data: ", data.agreement);
    if (data.agreement && data.payment) {
      setValue(true);
      checkbtn(true);
    }
  };

  const data = [
    {
      path: stripelogo,
      text: "Manage payments via credit/debit cards and bank transfers with Stripe, offering global reach and full control over your revenue",
    },
    {
      path: paypallogo,
      text: "Easily accept payments through PayPal, a widely trusted global platform for secure transactions.",
    },
    {
      path: bitpaylogo,
      text: "Accept fast, borderless payments in digital currencies for quick and secure global transactions.",
    },
    {
      path: paystacklogo,
      text: "Enable localized payments with Paystack, providing seamless transactions within Nigeria and across Africa.",
    },
    {
      path: phonepelogo,
      text: "Accept localized payments from users in India using Razorpay, India’s leading payment app, including UPI, PhonePe, and Paytm",
    },
    {
      path: pesalogo,
      text: "Leverage M-PESA to manage mobile-based payments across East Africa with ease and security.",
    },
  ];

  return (
    <Box>
      {value ? (
        <Typography>
          <PaymentIntegrationoptions />
        </Typography>
      ) : (
        <Box>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: "16.8px",
              mt: 2,
              color: "#1C2630",
              letterSpacing: "1px",
            }}
          >
            At POSTPAL, we provide a range of flexible, secure, and localized
            payment solutions designed to meet the diverse needs of our global
            forwarder partners. Whether you're processing international
            transactions or localized payments, you can select the option that
            works best for your business.
          </Typography>

          <Grid container spacing={2} mt={1}>
            {data.map((row, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Box
                  sx={{
                    border: "1px solid #E0E0E0",
                    whiteSpace: "normal",
                    borderRadius: "7px",
                  }}
                >
                  <Box
                    sx={{
                      padding: "15px 21px",
                      paddingTop:
                        row.text.includes("PhonePe") === true ? "15px" : "25px",
                    }}
                  >
                    <img
                      src={row.path}
                      alt="logo"
                      width={row.text.includes("PhonePe") === true && "90px"}
                    />
                  </Box>
                  <Box sx={{ paddingBottom: "25px" }}>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 400,
                        lineHeight: "16.8px",
                        padding: "1px 18px",
                        letterSpacing: "1px",
                      }}
                    >
                      {row.text}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>

          <Legalcomponet
            onLegalChange={handleLegalChange}
            onButtonClick={handleButtonClick}
          />
        </Box>
      )}
    </Box>
  );
}
